import { REPORT_CONSIGNEE_TERBANYAK_PER_DAERAH } from "./../actions/reportConsigneeTerbanyakPerDaerah";

const reportConsigneeTerbanyakPerDaerahReducer = (state = {}, action) => {
  switch (action.type) {
    case REPORT_CONSIGNEE_TERBANYAK_PER_DAERAH + "_LOADING":
      return {
        loading: true,
        error: false,
        success: false,
        data: [],
      };
    case REPORT_CONSIGNEE_TERBANYAK_PER_DAERAH + "ERROR":
      return {
        loading: false,
        error: true,
        success: false,
        data: [],
      };
    case REPORT_CONSIGNEE_TERBANYAK_PER_DAERAH + "_SUCCESS":
      return {
        loading: false,
        error: false,
        success: true,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default reportConsigneeTerbanyakPerDaerahReducer;
